/**
 * Spanish translations for locations
 */

export const SPANISH_TRANSLATIONS = {
  countries: {
    'United States': 'Estados Unidos',
    'Puerto Rico': 'Puerto Rico'
  },
  states: {
    // US States in Spanish
    'Alabama': 'Alabama',
    'Alaska': 'Alaska', 
    'Arizona': 'Arizona',
    'Arkansas': 'Arkansas',
    'California': 'California',
    'Colorado': 'Colorado',
    'Connecticut': 'Connecticut',
    'Delaware': 'Delaware',
    'Florida': 'Florida',
    'Georgia': 'Georgia',
    'Hawaii': 'Hawái',
    'Idaho': 'Idaho',
    'Illinois': 'Illinois',
    'Indiana': 'Indiana',
    'Iowa': 'Iowa',
    'Kansas': 'Kansas',
    'Kentucky': 'Kentucky',
    'Louisiana': 'Luisiana',
    'Maine': 'Maine',
    'Maryland': 'Maryland',
    'Massachusetts': 'Massachusetts',
    'Michigan': 'Míchigan',
    'Minnesota': 'Minnesota',
    'Mississippi': 'Misisipi',
    'Missouri': 'Misuri',
    'Montana': 'Montana',
    'Nebraska': 'Nebraska',
    'Nevada': 'Nevada',
    'New Hampshire': 'Nuevo Hampshire',
    'New Jersey': 'Nueva Jersey',
    'New Mexico': 'Nuevo México',
    'New York': 'Nueva York',
    'North Carolina': 'Carolina del Norte',
    'North Dakota': 'Dakota del Norte',
    'Ohio': 'Ohio',
    'Oklahoma': 'Oklahoma',
    'Oregon': 'Oregón',
    'Pennsylvania': 'Pensilvania',
    'Rhode Island': 'Rhode Island',
    'South Carolina': 'Carolina del Sur',
    'South Dakota': 'Dakota del Sur',
    'Tennessee': 'Tennessee',
    'Texas': 'Texas',
    'Utah': 'Utah',
    'Vermont': 'Vermont',
    'Virginia': 'Virginia',
    'Washington': 'Washington',
    'West Virginia': 'Virginia Occidental',
    'Wisconsin': 'Wisconsin',
    'Wyoming': 'Wyoming',
    'Puerto Rico': 'Puerto Rico'
  },
  cities: {
    // Major US cities in Spanish
    'New York': 'Nueva York',
    'Los Angeles': 'Los Ángeles',
    'Chicago': 'Chicago',
    'Houston': 'Houston',
    'Phoenix': 'Phoenix',
    'Philadelphia': 'Filadelfia',
    'San Antonio': 'San Antonio',
    'San Diego': 'San Diego',
    'Dallas': 'Dallas',
    'San Jose': 'San José',
    'Austin': 'Austin',
    'Jacksonville': 'Jacksonville',
    'Fort Worth': 'Fort Worth',
    'Columbus': 'Columbus',
    'Charlotte': 'Charlotte',
    'San Francisco': 'San Francisco',
    'Indianapolis': 'Indianápolis',
    'Seattle': 'Seattle',
    'Denver': 'Denver',
    'Washington': 'Washington D.C.',
    'Boston': 'Boston',
    'El Paso': 'El Paso',
    'Nashville': 'Nashville',
    'Detroit': 'Detroit',
    'Oklahoma City': 'Ciudad de Oklahoma',
    'Portland': 'Portland',
    'Las Vegas': 'Las Vegas',
    'Memphis': 'Memphis',
    'Louisville': 'Louisville',
    'Baltimore': 'Baltimore',
    'Miami': 'Miami',
    'Atlanta': 'Atlanta',
    'New Orleans': 'Nueva Orleans'
  }
} as const;

/**
 * Helper function to translate location names to Spanish
 */
export const translateToSpanish = (text: string, type: 'countries' | 'states' | 'cities'): string => {
  const translations = SPANISH_TRANSLATIONS[type] as Record<string, string>;
  return translations[text] || text;
};
